angular.module("warsApp.directives").directive("objectPropertyName", function () {
    return {
        restrict: "A",
        link: function (scope, element) {
            var func = function (event) {
                var alphaUnderscoreOnly = /[^A-Za-z\_]/g;
                var alphaNumericUnderscore = /[^A-Za-z0-9\_]/g;
                if (event && event.keyCode) {
                    if (event.keyCode === 37
                        || event.keyCode === 39
                        || event.keyCode === 8) return;
                }
                if (element.val().length > 0) {   
                    if (alphaUnderscoreOnly.test(element.val()[0])) {
                        element.val(element.val().substr(1));
                        element[0].selectionEnd = 0;
                    } else {
                        var cursorPosition = element[0].selectionEnd;
                        if (alphaNumericUnderscore.test(element.val())) {
                            element.val(element.val().replace(alphaNumericUnderscore, ""));
                            element[0].selectionEnd = cursorPosition - 1;
                        }
                    }
                }
            }
            element.keyup(func).blur(func);
        }
    };
});